// src/padplanner/ReadFailed.jsx
//
// A read that failed, said as one: "Couldn't load <what>" and a Retry. Every
// PadPlanner list and summary shows this in place of its answer, never an
// empty one: an empty list, a zero count or "No plans yet" reads as data.

/** error: a message, an Error, or nothing. */
export default function ReadFailed({ what, error = null, onRetry = null, testid = "pp-read-failed", className = "" }) {
  const message = typeof error === "string" ? error : error?.message ?? null;
  return (
    <div role="alert" data-testid={testid} data-what={what}
      className={`flex flex-wrap items-center gap-2 text-sm text-accent-red ${className}`}>
      <span>Couldn't load {what}{message ? `: ${message}` : "."}</span>
      {onRetry && <button type="button" className="op-btn op-btn--sm" data-testid={`${testid}-retry`} onClick={onRetry}>Retry</button>}
    </div>
  );
}
